import { render, staticRenderFns } from "./VServiceFormFieldsCard.vue?vue&type=template&id=66830424"
import script from "./VServiceFormFieldsCard.vue?vue&type=script&lang=js"
export * from "./VServiceFormFieldsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports